export const GRAPHQL_VARIABLES = {
  contentType: 'image/png'
};

export const QUERY = `
   query companiesOne($filter: FilterFindOnecompaniesInput!){
     companiesOne(filter: $filter) {
         transactions {
            _id
            provider
            type
            amount
            status
            note
            createdAt
            ccFee
            txId 
            payerId 
            payMethodId 
            refund{ createdAt }
         }
     }
 }
 `;
